import { useRouter } from 'next/router'
import { useContext, useRef, useState } from 'react'
import { DEFAULT_BODY } from '../constants/all'
import useTranslation from '../hooks/useTranslation'
import ImageWithBasePath from './ImageWithBasePath'
import {
  advertiserAnalyticOptions,
  logOutHandler,
  seekersAnalayticOptions
} from '../utils/functions'
import { clearAllAuth } from '@/utils/auth'
import { OpenPlayStore } from './OpenPlayStore'
import { useRouterHook } from '../hooks/useRouterHook'
import { trackEvent } from '../analytics'
import { Media } from '../commonComponents/Media'
import classNames from 'classnames'
import { con } from '../constants/advertiser'
import { NextLink } from '../commonComponents/NextLink'
import { HamburgerAnimation } from './HamburgerAnimation'
import advertiser_logo from '../../public/assets/advertiser_logo.webp'
import Image from 'next/image'
import { SharedContext } from '@/context/SharedContext'

const Line = () => {
  return <div className="border-[0px] border-b-xs border-solid border-[#E3E5E8]" />
}

const NavSection = ({
  setMenuClicked,
  setScrollBar,
  translation,
  setBody,
  isHire,
  windowSize,
  location
}) => {
  const router = useRouter()
  const { routerBackNavigation, navigateToPagesInAdvertiser } = useRouterHook()
  const sectionsDetails = useRef([
    {
      name: translation?.home,
      image: 'home',
      path: 'seekerHomePage',
      type: 'route',
      props: { as: location ? `jobs/${location?.name || location?.title}` : `jobs` }
    },
    {
      name: translation?.exploreJobs,
      image: 'work_outline',
      path: 'jobsFiltering',
      type: 'route',
      props: {
        as: location ? `jobs/jobs-in-${location?.name || location?.title}` : `jobs/jobs-near-me`
      }
    },
    {
      name: translation?.postAJob,
      image: 'post_add',
      path: 'advertiserHomePage'
    }
  ])

  const redirectPage = async (pathName) => {
    if (pathName) {
      setMenuClicked(false)
      setScrollBar(true)
      if (pathName == '/jobsFiltering') {
        setBody(DEFAULT_BODY)
        if (router?.pathname == '/jobsFiltering') {
          return true
        }
      }
      if (pathName === '/seekerHomePage' && router.pathname === '/seekerHomePage') {
        if (windowSize < 650) routerBackNavigation()
        return true
      }
    }
  }

  const navigateToHire = async () => {
    window?.open(process.env.NEXT_PUBLIC_APP_URL + 'hire', '_self')
  }

  return (
    <div className="my-[24px] space-y-[24px] font-noto-sans sm:mt-[0px] ">
      {sectionsDetails?.current?.map((item, index) => {
        return (
          <div key={index}>
            {(!isHire || (isHire && index === 2)) && (
              <NextLink
                id={item?.name + index}
                href={{
                  pathname: item?.path || 'seekerHomePage'
                }}
                as="jobs"
                isLoader={false}
                className="flex cursor-pointer items-center space-x-[16px]"
                key={index}
                {...item?.props}
                onClick={() => {
                  if (item?.name == translation?.postAJob) {
                    if (isHire)
                      navigateToPagesInAdvertiser({
                        pathName: 'advertiserPostJob',
                        as: 'post-job'
                      })
                    else navigateToHire()
                    setMenuClicked(false)
                    setScrollBar(true)
                    return true
                  } else if (item.type === 'route') redirectPage(item?.path)
                }}
              >
                <ImageWithBasePath src={item?.image} width={25} height={25} alt="recruiter image" />
                <div className="mr-[20px] flex flex-1 text-center text-md font-normal leading-[21.79px] text-[#323234]">
                  {item?.name}
                </div>
              </NextLink>
            )}
          </div>
        )
      })}
    </div>
  )
}

const ContactUs = ({ contact, translation, windowSize }) => {
  return (
    <div className="my-[24px] flex  flex-1 space-x-[16px] sm:m-[0px] sm:mt-[20px] sm:space-x-0 sm:border-[0px] sm:border-r-xs sm:border-solid sm:border-[#E5E5E5] sm:pr-[24px]">
      <Media at="sm">
        <ImageWithBasePath src="contact_support" width={25} height={25} alt="contact support" />
      </Media>
      <div className="space-y-[20px] font-noto-sans font-normal">
        <div className="">
          <div className="pb-[4px] font-noto-sans text-[14px] font-normal text-[#191919]">
            {translation?.contactUs}
          </div>
          {/* <div className="text-[12px] leading-[19.2px] text-[#0174D3] sm:text-[12px] sm:leading-[19.02px]">
            +{contact?.countryCode}{' '}
            <a
              href={`tel:${contact?.number}`}
              onClick={(e) => {
                if (windowSize > 640) e.preventDefault()
              }}
              className="cursor-pointer text-[#0174D3] no-underline"
            >
              {contact?.number}
            </a>
          </div> */}
          <a
            href={`mailto:${contact?.email}`}
            className="cursor-pointer truncate text-base leading-[22.4px] text-[#0174D3] no-underline sm:text-[12px] sm:leading-[19.02px]"
          >
            {contact?.email}
          </a>
        </div>
        <Line />
      </div>
      <Line />
    </div>
  )
}

const Login = ({
  setLogInOpen,
  translation,
  setMenuClicked,
  isHire,
  navigateToPagesInAdvertiser
}) => {
  return (
    <div
      onClick={() => {
        if (isHire) {
          setMenuClicked(false)
          navigateToPagesInAdvertiser({
            pathName: 'advertiserHomePage',
            as: '',
            isHome: true
          })
        } else setLogInOpen(true)
      }}
    >
      {isHire ? (
        translation?.login
      ) : (
        <div className="my-[24px] flex cursor-pointer items-center space-x-[16px] text-[#323234]">
          <ImageWithBasePath src="log_in" width={20} height={18} alt="log_in" />
          <div className="leading-[ 21.79px] text-md font-normal text-[#323234]">
            {translation?.login}
          </div>
        </div>
      )}
      {/* {isHire ? translation?.login : translation?.loginOrCreateAnAccount} */}
    </div>
  )
}

const UserDetails = ({
  loginDetails,
  isJobProfileCreated,
  countryCode,
  translation,
  setMenuClicked,
  setScrollBar,
  cookie,
  utmParams,
  location,
  isHire,
  enterpriseLoginDetails
}) => {
  const jumpToJobProfile = async () => {
    const user = await cookie.get('user')
    trackEvent({
      name: 'tap_create_profile',
      searchParams: {
        ...utmParams
      },
      options: {
        ...seekersAnalayticOptions(window, loginDetails, location, 'tap', 'listings_page'),
        source: 'hamburger menu'
      },
      isSeeker: true
    })
    if (!user) cookie.set('user', loginDetails?.id, { path: '/' })

    setMenuClicked(false)
    setScrollBar(true)
  }

  return (
    <div className="my-[20px] space-y-[20px] font-noto-sans">
      <div className="text-md font-bold leading-[21.79px] text-[#323232]">
        <div>{translation?.hi},</div>
        <div>
          +{countryCode} {loginDetails?.mobileNumber}
        </div>
      </div>
      <Line />
      {!isJobProfileCreated && !isHire ? (
        <NextLink
          id={'menu_create_profile'}
          href={{
            pathname: location ? 'create_profile' : 'locationSelectionPage'
          }}
          isLoader={false}
          as={location ? 'jobs/create_profile' : 'jobs/jobs-near-me/?clicked=create_profile'}
          className="flex cursor-pointer items-center space-x-[16px]"
          onClick={jumpToJobProfile}
        >
          <ImageWithBasePath src="person_outline" width={25} height={25} alt="person outline" />
          <div className="text-md font-normal leading-[21.79px] text-[#323234]">
            {translation?.createYourProfile}
          </div>
        </NextLink>
      ) : (
        !isHire && (
          <NextLink
            id={'My Profile'}
            href={{
              pathname: location ? 'create_profile' : 'locationSelectionPage'
            }}
            isLoader={false}
            as={location ? 'jobs/create_profile' : 'jobs/jobs-near-me/?clicked=create_profile'}
            className="flex cursor-pointer items-center space-x-[16px]"
            onClick={jumpToJobProfile}
          >
            <ImageWithBasePath src="person_outline" width={25} height={25} alt="person outline" />
            <div className="text-md font-normal leading-[21.79px] text-[#323234]">
              {translation?.myProfile}
            </div>
          </NextLink>
        )
      )}
      {isHire ? (
        <>
          <NextLink
            href={{
              pathname: 'profileDetails'
            }}
            as="/hire/profileDetails"
            isLoader={false}
            className="flex cursor-pointer items-center space-x-[16px]"
          >
            <ImageWithBasePath src="person_outline" width={22} height={22} alt="person outline" />
            <div className=" font-noto-sans text-[14px] font-normal text-[#191919]">
              {translation?.myProfile}
            </div>
          </NextLink>
          <NextLink
            href={{
              pathname: 'paymentHistory'
            }}
            as="/hire/paymentHistory"
            isLoader={false}
            className="flex cursor-pointer items-center space-x-[16px]"
          >
            <ImageWithBasePath src="ic_payments" width={22} height={22} alt="person outline" />
            <div className=" font-noto-sans text-[14px] font-normal  text-[#191919]">
              Payment history
            </div>
          </NextLink>
        </>
      ) : null}
    </div>
  )
}

const LogOut = ({
  translation,
  utmParams,
  loginDetails,
  location,
  cookie,
  setLoginDetails,
  setEnterpriseLoginDetails,
  isHire,
  type = 'mobile',
  enterpriseLoginDetails,
  setMenuClicked,
  setAdvertiserBackModalOpen,
  setAdvertiserMenuClicked,
  advertiserBackModalClose,
  setIsJobProfileCreated,
}) => {
  const { replaceThePageInAdvertiser, replaceToPagesInSeeker } = useRouterHook()

  const logoutAction = () => {
    clearAllAuth()
    replaceThePageInAdvertiser({
      pathName: 'advertiserSignIn',
      as: 'signin'
    })
  }

  return (
    <div
      className="my-[24px] flex cursor-pointer items-center space-x-[16px]"
      onClick={() => {
        const data = {
          utmParams,
          window,
          loginDetails,
          location,
          cookie,
          setLoginDetails,
          setEnterpriseLoginDetails,
          isHire,
          setIsJobProfileCreated
        }
        if (type === 'desktop') {
          setAdvertiserMenuClicked(false)

          if (isHire) {
            trackEvent({
              name: 'tap_logout',
              searchParams: { ...utmParams },
              options: advertiserAnalyticOptions({}),
              isFbPixelThere: false
            })
          }
          setAdvertiserBackModalOpen({
            isOpen: true,
            data: data,
            id: 'log out user',
            buttonTitles: [con.cancel, con.logOut],
            onClickActions: [advertiserBackModalClose, logoutAction],
            title: `${con.wantToLogOut}`,
            caption: ''
          })
        } else {
          setMenuClicked(false)
          if (!isHire) {
            replaceToPagesInSeeker({
              pathName: 'seekerHomePage',
              as: '',
              isHome: true
            })
          }
          logoutAction()
        }
      }}
    >
      <ImageWithBasePath src="log out" width={25} height={25} alt="log out" />
      <div className="leading-[ 21.79px] text-md font-normal text-[#323234]">
        {translation?.logOut}
      </div>
    </div>
  )
}

export const HamburgerMenu = ({
  setMenuClicked = () => {},
  setLogInOpen = () => {},
  isMenuClicked,
  isJobProfileCreated,
  setIsJobProfileCreated = () => {},
  setBody = () => {},
  enterpriseLoginDetails,
  setEnterpriseLoginDetails = () => {},
  setAdvertiserBackModalOpen = () => {},
  setAdvertiserMenuClicked = () => {},
  advertiserBackModalClose = () => {}
}) => {
  const {
    loginDetails,
    setLoginDetails,
    setSkeletonloader,
    cookie,
    setShowToast,
    setScrollBar,
    utmParams,
    location,
    windowSize
  } = useContext(SharedContext)

  const translation = useTranslation()

  const contact = useRef({
    number: 2047170323,
    countryCode: '91',
    email: 'support@getlokalapp.com'
  })
  const router = useRouter()
  const hirePathRegex = /^(?:\/hire|\/recruit)(?:[\/?#].*)?$/
  const isHire = hirePathRegex.test(router?.asPath)
  const countryCode = '91'
  const { navigateToPagesInAdvertiser } = useRouterHook()

  return (
    <div
      className={classNames(
        'flex flex-col overflow-hidden px-[18px] font-noto-sans sm:w-[392.46px] sm:rounded-[10px] sm:border-xs sm:border-solid sm:border-[#404040] sm:border-opacity-10 sm:p-[28px] sm:shadow-default',
        isHire && 'sm:w-[270px]'
      )}
    >
      {isHire && isMenuClicked && (
        <Media at="sm">
          <div className="sticky top-0 z-20 flex h-[44px] items-center justify-between bg-white">
            <div className="relative h-[20.91px] w-[105px] cursor-pointer">
              <Image src={advertiser_logo} fill alt="getlokalapp logo" priority={true} />
            </div>
            <div
              className="flex h-fit w-fit cursor-pointer items-center pl-[10px]"
              onClick={() => {
                setMenuClicked((prv) => !prv)
                setScrollBar((prv) => !prv)
              }}
            >
              <HamburgerAnimation {...{ isClicked: isMenuClicked }} />
            </div>
          </div>
        </Media>
      )}
      <div className="animate-slide sm:animate-none">
        <Media at="sm">
          {loginDetails?.isLogIn ? (
            <UserDetails
              {...{
                loginDetails,
                setSkeletonloader,
                router,
                isJobProfileCreated,
                countryCode,
                translation,
                setMenuClicked,
                setScrollBar,
                cookie,
                setShowToast,
                utmParams,
                location,
                isHire,
                enterpriseLoginDetails
              }}
            />
          ) : (
            <Login
              {...{
                setLogInOpen,
                translation,
                isHire,
                navigateToPagesInAdvertiser,
                setMenuClicked
              }}
            />
          )}
          <Line />
        </Media>
        {isHire && (
          <Media greaterThan="sm">
            {loginDetails?.isLogIn ? (
              <>
                <UserDetails
                  {...{
                    loginDetails,
                    setSkeletonloader,
                    router,
                    isJobProfileCreated,
                    countryCode,
                    translation,
                    setMenuClicked,
                    setScrollBar,
                    cookie,
                    setShowToast,
                    utmParams,
                    location,
                    isHire,
                    enterpriseLoginDetails
                  }}
                />
                <Line />
              </>
            ) : (
              <Login
                {...{
                  setLogInOpen,
                  translation,
                  isHire,
                  navigateToPagesInAdvertiser,
                  setMenuClicked
                }}
              />
            )}
          </Media>
        )}

        <Media at="sm">
          <NavSection
            {...{
              setMenuClicked,
              setScrollBar,
              translation,
              setSkeletonloader,
              setBody,
              isHire,
              windowSize,
              location
            }}
          />
        </Media>
        <Media greaterThan="sm">
          {!isHire && (
            <NavSection
              {...{
                setMenuClicked,
                setScrollBar,
                translation,
                setSkeletonloader,
                setBody,
                isHire,
                windowSize,
                location
              }}
            />
          )}
        </Media>
        {isHire && (
          <>
            <Media greaterThan="sm" className=" flex flex-1  ">
              <ContactUs contact={contact?.current} {...{ translation, windowSize }} />
            </Media>
            <Media greaterThan="sm">
              {loginDetails?.isLogIn && (
                <LogOut
                  {...{
                    logOutHandler,
                    translation,
                    utmParams,
                    loginDetails,
                    location,
                    cookie,
                    setLoginDetails,
                    setEnterpriseLoginDetails,
                    isHire,
                    type: 'desktop',
                    enterpriseLoginDetails,
                    setMenuClicked,
                    setAdvertiserBackModalOpen,
                    setAdvertiserMenuClicked,
                    advertiserBackModalClose,
                    setIsJobProfileCreated
                  }}
                />
              )}
            </Media>
          </>
        )}
        <div className=" items-center   sm:flex">
          <Media at="sm">
            <ContactUs contact={contact?.current} {...{ translation, windowSize }} />
          </Media>

          <Media at="sm">
            <Line />
            {loginDetails?.isLogIn && (
              <LogOut
                {...{
                  logOutHandler,
                  translation,
                  utmParams,
                  loginDetails,
                  location,
                  cookie,
                  setLoginDetails,
                  setEnterpriseLoginDetails,
                  isHire,
                  enterpriseLoginDetails,
                  setMenuClicked,
                  setAdvertiserBackModalOpen,
                  setAdvertiserMenuClicked,
                  advertiserBackModalClose,
                  setIsJobProfileCreated
                }}
              />
            )}
            <Line />
          </Media>
          <Media at="sm">
            <OpenPlayStore {...{ translation }} />
          </Media>
          {!isHire && (
            <Media greaterThan="sm" className=" flex-1">
              <div
                className="ml-[24px] mt-[10.5px]"
                onClick={() =>
                  window.open('https://play.google.com/store/apps/details?id=get.lokal.localnews')
                }
              >
                <ImageWithBasePath
                  src="google_play_store"
                  width={138.46}
                  height={40}
                  alt={'google play store'}
                />
              </div>
            </Media>
          )}
        </div>
      </div>
    </div>
  )
}
